export default __webpack_public_path__ + "static/media/ComicSansMS-Bold.ac994dc2.ttf";